<template>
  <div class="preview-box">
    <!-- 代理佣金预览 -->
    <div class="preview-section">
      <!-- 标题 -->
      <h4>{{ibCommissionLan.ibCommissionPreview.ibCommissionPreview}}</h4>
      <!-- 表格 -->
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>{{ibCommissionLan.ibCommissionPreview.th.ibType}}</th>
            <th>{{ibCommissionLan.ibCommissionPreview.th.ibAccount}}</th>
            <th>{{ibCommissionLan.ibCommissionPreview.th.ibName}}</th>
            <th>{{ibCommissionLan.ibCommissionPreview.th.CommissionReturn}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in previewData.IB">
            <td>{{ibCommissionLan.ibCommissionPreview[item.type]}}</td>
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td v-if="item.mode==1 && item.cpa !== 'not set'">
              {{ibCommissionLan.CPACommission+" : "}}
              <span v-for="(data,key) in item.cpa">
                  {{data}} {{ibCommissionLan.ibCommissionPreview.unit}}
                  <span v-if="key < item.cpa.length-1">/</span>
              </span>
            </td>
            <td v-else-if="item.mode==0 && item.first !== 'not set'">
              {{ibCommissionLan.ruleCommission.internalCommission+" : "}}
              <span v-for="(data,key) in item.first">
                  {{data}} {{ibCommissionLan.ibCommissionPreview.unit}}
                  <span v-if="key < item.first.length-1">/</span>
              </span>
            </td>
            <td v-else-if="item.mode==2">
              {{ibCommissionLan.ruleCommission.internalCommission+" : "}}
              <span v-for="(data,key) in item.first" v-if="item.first !== 'not set'">
                  {{data}} {{ibCommissionLan.ibCommissionPreview.unit}}
                  <span v-if="key < item.first.length-1">/</span>
              </span>
              +
              {{ibCommissionLan.CPACommission+" : "}}
              <span v-for="(data,key) in item.cpa" v-if="item.cpa !== 'not set'">
                  {{data}} {{ibCommissionLan.ibCommissionPreview.unit}}
                  <span v-if="key < item.cpa.length-1">/</span>
              </span>
            </td>
            <td v-else></td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 下级代理佣金预览 -->
    <div class="preview-section" v-if="enableDistribution">
      <!-- 标题 -->
      <h4>{{ibCommissionLan.ibCommissionPreview.lowerIBCommissionPreview}}</h4>
      <!-- 表格 -->
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
              <th>{{ibCommissionLan.ibCommissionPreview.th.mainIBAccount}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.subIBAccount}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.ibName}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.getSubCondition}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in previewData.lowerIB">
            <td>{{previewData.mainIB}}</td>
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td>
              <div v-for="(rule,i) in item.rules">
                <div v-for="ruleSeqItem in ruleSeq" v-if="rule.ruleId == ruleSeqItem.ruleId">
                  {{i+1}}、
                  {{ ibCommissionRuleSettingLan[ruleSeqItem.langKey.split('.')[1]]}}
                  {{rule.ruleId && rule.ruleId < 3 ? '(' : ''}}
                      <span v-if="rule.spreadEnable">{{ibCommissionLan.ibCommissionPreview.rules.spreadCommission}},</span>
                      <span v-if="rule.externalCommissionEnable">{{ibCommissionLan.ibCommissionPreview.rules.externalCommission}},</span>
                      <span v-if="rule.internalCommissionEnable">{{ibCommissionLan.ibCommissionPreview.rules.internalCommission}}</span>
                  {{rule.ruleId && rule.ruleId < 3 ? ')' : ''}}
                  :
                  {{rule.value}} {{rule.ruleId && rule.ruleId < 3 ? '%' : 'USD'}}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 特别代理佣金预览 -->
    <div class="preview-section" v-if="enableDistribution">
      <!-- 标题 -->
      <h4>{{ibCommissionLan.ibCommissionPreview.specialIBCommissionPreview}}</h4>
      <!-- 表格 -->
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
              <th>{{ibCommissionLan.ibCommissionPreview.th.mainIBAccount}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.specialIBAccount}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.ibName}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.originalMainAccount}}</th>
              <th>{{ibCommissionLan.ibCommissionPreview.th.getSpecialCondition}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in previewData.specialIB">
            <td>{{previewData.mainIB}}</td>
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td>{{item.original}}</td>
            <td>
              <div v-for="(rule,i) in item.rules">
                <div v-for="ruleSeqItem in ruleSeq" v-if="rule.ruleId == ruleSeqItem.ruleId">
                  {{i+1}}、
                  {{ ibCommissionRuleSettingLan[ruleSeqItem.langKey.split('.')[1]]}}
                  {{rule.ruleId && rule.ruleId < 3 ? '(' : ''}}
                      <span v-if="rule.spreadEnable">{{ibCommissionLan.ibCommissionPreview.rules.spreadCommission}},</span>
                      <span v-if="rule.externalCommissionEnable">{{ibCommissionLan.ibCommissionPreview.rules.externalCommission}},</span>
                      <span v-if="rule.internalCommissionEnable">{{ibCommissionLan.ibCommissionPreview.rules.internalCommission}}</span>
                  {{rule.ruleId && rule.ruleId < 3 ? ')' : ''}}
                  :
                  {{rule.value}} {{rule.ruleId && rule.ruleId < 3 ? '%' : 'USD'}}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { Api } from 'api/commissionEnv'
  import { URL_IBPREVIEW } from 'api/commissionApi'
  var api = new Api()

  export default {
    props: ['region','ibCommissionLan'],
    mixins: [
      require("common/mixin/base.js").base({ibCommissionRuleSettingLan:"ibCommissionRuleSetting"}),
    ],
    data () {
      return {
        enableDistribution: api.enableDistribution,
        previewData: {
          mainIB: this.$route.query.id,
          IB: [],
          lowerIB: [],
          specialIB: [],
        },
        ruleSeq: [],
      }
    },
    mounted () {
      this.pageInit()
    },
    methods: {
      pageInit() {
        this.$http.get(api.getUrl20(this.region,URL_IBPREVIEW+'/'+this.$route.query.id)).then((res) => {
          this.previewData.IB = res.data.data.IB
          this.previewData.lowerIB = res.data.data.lowerIB
          this.previewData.specialIB = res.data.data.specialIB
          this.ruleSeq = res.data.data.ruleSeq
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .preview-box{
    border:1px solid #ddd;
    margin: 0 20px 0 20px;
    padding: 20px;
    .preview-section{
      margin-bottom: 40px;
      h4{
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      table{
        border-top:2px solid #3F51B5;
        thead tr {
            background-color: #EBEDF7;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ibCommissionPreview.vue?d9f126aa